<div class="metadata-fields" [attr.data-automation-id]="automationId + '-container'">
    <div class="header-bar" [attr.data-automation-id]="automationId + '-header'">
        <button type="button" [attr.data-automation-id]="automationId + '-save-button'" class="primary-button"
            (click)="saveChanges()" [disabled]="isSaveDisabled()" *ngIf="hasCreatePermissions">Save</button>
        <button type="button" [attr.data-automation-id]="automationId + '-discard-changes-button'"
            class="secondary-button" (click)="discardChanges()" [disabled]="isDiscardDisabled()"
            *ngIf="hasCreatePermissions">Discard
            Changes</button>
        <button type="button" class="help-button" [attr.data-automation-id]="automationId + '-help-button'"
            (click)="openHelp()"><i class="fa fa-question"></i></button>
    </div>
    <form class="content" #contentForm="ngForm" [attr.data-automation-id]="automationId + '-content'"
        [resBusySpinner]="isBusy" [message]="isBusyMessage">
        <res-left-right-selection-box [useDragAndDrop]="useDragAndDrop" [automationId]="automationId"
            [leftListSize]="50" [itemsLeft]="itemsLeft" [itemsRight]="itemsRight" leftListTitle="Available Fields"
            [rightListTitle]="rightListTitle" [leftListGridContext]="leftListGridContext"
            [rightListGridContext]="rightListGridContext" [leftListColumns]="leftListColumns"
            [rightListColumns]="rightListColumns" [sortItemsLeft]="true" [sortItemsRight]="sortItemsRight"
            [hasViewOnlyPermissions]="!hasCreatePermissions" (customMoveItems)="itemsChanged($event)"
            (customOnDropItems)="afterDropUpdate($event)" [showLeftRightButton]="showLeftRightButton"
            [showRightHeaderContextMenu]="showRightHeaderContextMenu"
            [adjustHeaderCheckboxStyles]="adjustHeaderCheckboxStyles" [isMetadataViewFields]="useDragAndDrop">
        </res-left-right-selection-box>
    </form>
</div>